<div class="thanks-el-container" [style]="getBorder(texts.border ?? true)" [ngClass]="{'active-red': isHighlighted}" #block>
<!--    <div class="col-5">-->
<!--        {{ texts.title }}-->
<!--    </div>-->
<!--    <div class="col-7">-->
        {{ texts.text }}
<!--    </div>-->
</div>
